export default {
  Title: "角色管理",
  rName: "名称",
  cName: "所属企业",
};
